/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Alexandre RIBEIRO
 * @date        15/04/2022 16:45
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import '@ipbmd365/scss/app.scss';
import DependentFields from './Fields/Depends';

document.addEventListener( "DOMContentLoaded", function () {
	new DependentFields();
});